// import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { OrdersExcelActionTypes } from "./types/actionTypes";
import { OrdersExcelState } from "./types";
import { OrdersExcelActions } from "./actionCreators";

const initialState: OrdersExcelState = {
  code: "",
};

const ordersExcelReducer = (
  state = initialState,
  action: OrdersExcelActions
): OrdersExcelState => {
  switch (action.type) {
    case OrdersExcelActionTypes.FETCH_ORDERS_EXCEL_SUCCESS: {
      return {
        ...state,
        code: action.payload.code,
      };
    }
    case OrdersExcelActionTypes.RESET_ORDERS_EXCEL: {
      return {
        ...state,
        code: "",
      };
    }
    default:
      return state;
  }
};
export default ordersExcelReducer;
